import { render, staticRenderFns } from "./ConsultAdvisorPage.vue?vue&type=template&id=3b28c0ca"
import script from "./ConsultAdvisorPage.vue?vue&type=script&lang=ts"
export * from "./ConsultAdvisorPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultAdvisorPage.vue?vue&type=style&index=0&id=3b28c0ca&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports